module.exports = __webpack_public_path__ + "img/page32.eb224fd6.gif";